import Transitions from './modules/transitions.js';
import Nav from './modules/nav.js';


let ranges = [];
let sliders = [];
window.mainGroupes = window.mainGroupes || [];
window.appartements = window.appartements || {};


function ready(fn)
{
	if(document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
    	fn();
  	} else {
    	document.addEventListener('DOMContentLoaded', fn);
	}
}

ready(init);

async function init()
{
	gsap.registerPlugin(ScrollTrigger, SplitText, CSSRulePlugin);
 
	const transitions = new Transitions();
	const nav = new Nav();

	if(document.querySelector('.row-entete')) {
		gsap.set(".row-entete .entete-container .media-container img", {marginTop:0});
	}

	if(document.querySelector('.row-nos-projets')) {
		gsap.set(".row-nos-projets", {marginTop:0});
	}

	if(document.querySelector('.tiny-slider')) {
		let sliders = gsap.utils.toArray(".tiny-slider");
		const { default:Slider } = await import('./modules/slider.js');
		sliders.forEach(sliderElement =>
		{
			const slider = new Slider(sliderElement);
			sliders.push(slider);
		});   
	}

	if (document.querySelector('.range-slider')) {
		let ranges = gsap.utils.toArray(".range-slider");
		const { default:Range } = await import('./modules/range.js');
		ranges.forEach(rangeElement =>
		{
			const range = new Range(rangeElement);
			ranges.push(range);
		});   
    }

	if (document.querySelector('.gmap')) {
        const { default:Map } = await import('./modules/map.js');
        const map = new Map();
    }

	if(document.querySelector('.row-articles')) {
		const { default:Blog } = await import('./modules/blog.js');
		const blog = new Blog(transitions);
	}

	if(document.querySelector('.project-units .types-form select') || document.querySelectorAll('.units-container .plus')) {
		const { default:Units } = await import('./modules/units.js');
		const units = new Units(transitions);
	}

	if(document.querySelector('.wpcf7-select[name="quartier"]')) {
		const { default:Form } = await import('./modules/form.js');
		const form = new Form();
	}

	if(document.querySelector('.copier')) {
		document.querySelector('.copier').addEventListener('click', function(e) {
			let currentUrl = window.location.href;
			navigator.clipboard.writeText(currentUrl).then(function()
			{
				console.log('Copié !');
			}, function(err) {
				console.error('Impossible de copier : ', err);
			});
		});
	}

	initLenis();
	
	//window.addEventListener("resize", resizeHandler);
	//resizeHandler();
}

export async function getAppartements()
{
	return window.appartements;
}


export async function getGroupes()
{
	return window.mainGroupes;
}


export async function initNewSlider(selector)
{
	const { default: Slider } = await import('./modules/slider.js');
	let sliders = gsap.utils.toArray(".tiny-slider" + selector);
	sliders.forEach(sliderElement =>
	{
		const slider = new Slider(sliderElement);
		sliders.push(slider);
	});   
}


// Ajuster les champs Quartier et Projet du formulaire en fonction de l'appartement cliqué. Préremplir le champ caché app_number aussi.
export async function initLinksNumber(selector)
{
	let linksWithNumberAtt = document.querySelectorAll(selector);
	linksWithNumberAtt.forEach(link =>
	{
		link.addEventListener("click", (e) =>
		{
			e.preventDefault();

			let quartier = document.querySelector('.row-contact > .one-half:last-child').dataset.quartier;
            if(quartier != "") {
                let quartierField = document.querySelector('.row-contact .wpcf7 select[name="quartier"]');
                if(quartierField) {
                    Array.from(quartierField.options).forEach(option => {
                        if (option.text === quartier) {
                            option.selected = true;
                        }
                    });
                    
                    quartierField.dispatchEvent(new Event('change'));
                }
            }

			let targetElementId = e.currentTarget.getAttribute("href").substring(1);
			scrollToElementById(targetElementId);
			document.querySelector(".wpcf7 input[name='app_number']").value = e.currentTarget.dataset.number;
			return false;
		});
	});
}


export async function scrollToElementById(id)
{
	setTimeout(() => {
		const element = document.getElementById(id);
		if (element) {
			let elementPosition = element.offsetTop;
			window.scrollTo({top: elementPosition - 140, behavior:"instant"});
			//element.scrollIntoView({behavior: "smooth", block: "start"});
		}
	}, 20);
}


function initLenis()
{
	//<div data-lenis-prevent-wheel></div> to prevent wheel events

	const lenis = new Lenis({
		touchMultiplier: 0
	});

	ScrollTrigger.normalizeScroll(true);
	lenis.on('scroll', ScrollTrigger.update);

	gsap.ticker.add((time)=>
	{
		lenis.raf(time * 1000);
	})

	gsap.ticker.lagSmoothing(0);
}


function resizeHandler(e)
{

}